// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"316":"0e4f8f73","497":"a9e83a7d"}[chunkId] + ".chunk.css";
};